const minutes = (value, fallback) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
};

export const IDLE_TIMEOUT_MS = minutes(process.env.REACT_APP_SESSION_IDLE_MINUTES, 30) * 60 * 1000;
export const WARNING_MS = 60 * 1000;

const ACTIVITY_KEY = "fd_last_activity";
const REASON_KEY = "fd_signout_reason";

/** Last activity across all open tabs (shared through localStorage). */
export function lastActivity() {
  try {
    const n = Number(localStorage.getItem(ACTIVITY_KEY));
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

export function markActivity(now = Date.now()) {
  try {
    localStorage.setItem(ACTIVITY_KEY, String(now));
  } catch {
    /* storage unavailable: the in-memory timer still works */
  }
}

export function clearActivity() {
  try {
    localStorage.removeItem(ACTIVITY_KEY);
  } catch {
    /* ignore */
  }
}

/** Milliseconds left before the idle sign-out; never negative. */
export function remainingMs(last, now = Date.now(), timeout = IDLE_TIMEOUT_MS) {
  if (!last) return timeout;
  return Math.max(0, last + timeout - now);
}

/** Why the previous session ended ("timeout", "disabled", "session_limit"), shown once on the login page. */
export function setSignOutReason(reason) {
  try {
    sessionStorage.setItem(REASON_KEY, reason);
  } catch {
    /* ignore */
  }
}

export function consumeSignOutReason() {
  try {
    const reason = sessionStorage.getItem(REASON_KEY);
    sessionStorage.removeItem(REASON_KEY);
    return reason;
  } catch {
    return null;
  }
}
